<template lang="pug">
    v-sheet.mb-2(
        v-bind:style="{ height: sheetHeight + 'px' }"
        color="white"
        elevation="2"
        rounded
        style="padding: 0 !important;"
    )

        v-simple-table(style="width: 100%;" v-if="validBaseDashboardSummary && !teamScopeEmptyMessage")
            template(v-slot:default)
                tbody
                    tr
                        //- td.no-wrap.lg-width.xs-height.task-border-right
                        //-     .d-flex.align-center
                        //-         .ml-2.mr-1.text-left
                        //-             .text-subtitle-1.font-weight-medium.volie-color-blue Outbound Calls
                        //-             .text-h4.font-weight-bold {{ currentBaseDashboardSummary.base_dashboard_summary.remaining_phone_default_campaign_customer_count | number }}
                        //-         v-spacer
                        //-         .ml-auto
                        //-             v-icon.volie-color-blue(size="45")
                        //-                 | mdi-phone-outgoing

                        td.no-wrap.lg-width.xs-height.task-border-right
                            .d-flex.align-center
                                .ml-2.mr-1.text-left
                                    .text-subtitle-1.font-weight-medium.volie-color-blue Return Emails
                                    .text-h4.font-weight-bold {{ currentBaseDashboardSummary.base_dashboard_summary.remaining_return_email_campaign_customer_count | number }}
                                v-spacer
                                .ml-auto
                                    v-icon.volie-color-blue(size="45")
                                        | mdi-email

                        td.no-wrap.lg-width.xs-height.task-border-right.task-border-left
                            .d-flex.align-center
                                .ml-2.mr-1.text-left
                                    .text-subtitle-1.font-weight-medium.volie-color-blue Return Messages
                                    .text-h4.font-weight-bold {{ currentBaseDashboardSummary.base_dashboard_summary.remaining_return_message_campaign_customer_count | number }}
                                v-spacer
                                .ml-auto
                                    v-icon.volie-color-blue(size="45")
                                        | mdi-cellphone

                        td.no-wrap.lg-width.xs-height.task-border-right.task-border-left
                            .d-flex.align-center
                                .ml-2.mr-1.text-left
                                    .text-subtitle-1.font-weight-medium.volie-color-blue Missed Calls
                                    .text-h4.font-weight-bold {{ currentBaseDashboardSummary.base_dashboard_summary.remaining_missed_call_count | number }}
                                v-spacer
                                .ml-auto
                                    v-icon.volie-color-blue(size="45")
                                        | mdi-phone-missed

                        td.no-wrap.lg-width.xs-height.task-border-right.task-border-left
                            .d-flex.align-center
                                .ml-2.mr-1.text-left
                                    .text-subtitle-1.font-weight-medium.volie-color-blue Callbacks
                                    .text-h4.font-weight-bold {{ currentBaseDashboardSummary.base_dashboard_summary.remaining_scheduled_communication_count | number }}
                                v-spacer
                                .ml-auto
                                    v-icon.volie-color-blue(size="45")
                                        | mdi-phone-incoming-outgoing

                        td.no-wrap.lg-width.xs-height.task-border-right.task-border-left
                            .d-flex.align-center
                                .ml-2.mr-1.text-left
                                    .text-subtitle-1.font-weight-medium.volie-color-blue Hot Alerts
                                    .text-h4.font-weight-bold {{ currentBaseDashboardSummary.base_dashboard_summary.remaining_alert_type_survey_count | number }}
                                v-spacer
                                .ml-auto
                                    v-icon.volie-color-blue(size="45")
                                        | mdi-alert-circle

                        td.no-wrap.lg-width.xs-height.task-border-right.task-border-left
                            .d-flex.align-center
                                .ml-2.mr-1.text-left
                                    .text-subtitle-1.font-weight-medium.volie-color-blue Email Deployments
                                    template(v-if="currentBaseDashboardSummary.base_dashboard_summary.remaining_in_progress_email_campaign_deployment_count > 0")
                                        v-tooltip(top)
                                            template(v-slot:activator='{ on, attrs }')
                                                span(v-bind="attrs" v-on="on" role="text")
                                                    .text-h4.font-weight-bold {{ currentBaseDashboardSummary.base_dashboard_summary.remaining_in_progress_email_campaign_deployment_count | number }}
                                            span
                                                | {{ currentBaseDashboardSummary.base_dashboard_summary.remaining_email_campaign_customer_deployment_count | number }} emails
                                    template(v-else)
                                        .text-h4.font-weight-bold 0
                                v-spacer
                                .ml-auto
                                    v-icon.volie-color-blue(size="45")
                                        | mdi-email-fast

                        td.no-wrap.lg-width.xs-height.task-border-right.task-border-left
                            .d-flex.align-center
                                .ml-2.mr-1.text-left
                                    .text-subtitle-1.font-weight-medium.volie-color-blue SMS Deployments
                                    template(v-if="currentBaseDashboardSummary.base_dashboard_summary.remaining_in_progress_sms_message_campaign_deployment_count > 0")
                                        v-tooltip(top)
                                            template(v-slot:activator='{ on, attrs }')
                                                span(v-bind="attrs" v-on="on" role="text")
                                                    .text-h4.font-weight-bold {{ currentBaseDashboardSummary.base_dashboard_summary.remaining_in_progress_sms_message_campaign_deployment_count | number }}
                                            span
                                                | {{ currentBaseDashboardSummary.base_dashboard_summary.remaining_sms_message_campaign_customer_deployment_count | number }} SMS messages
                                    template(v-else)
                                        .text-h4.font-weight-bold 0
                                v-spacer
                                .ml-auto
                                    v-icon.volie-color-blue(size="45")
                                        | mdi-cellphone-text

        .d-flex.align-center.justify-center.px-4(v-else-if="teamScopeEmptyMessage" v-bind:style="{ height: sheetHeight + 'px' }")
            v-alert(type="info" dense outlined style="width: 100%;")
                | {{ teamScopeEmptyMessage }}

        .text-center(v-else)
            v-progress-circular(
                :size='50'
                :width='10'
                color='var(--volie-blue)'
                indeterminate
                style="margin-top: 25px;"
            )

</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        data() {
            return {
                isLoading: false,
            }
        },
        methods: {
        },
        computed: {
            validBaseDashboardSummary() {
                return this.currentBaseDashboardSummary?.base_dashboard_summary?.id > 0;
            },
        },
        components: {
        },
        props: {
            currentBaseDashboardSummary: Object,
            sheetHeight: Number,
            teamScopeEmptyMessage: String,
        },
        watch: {
        },
        destroyed() {
        },
        created() {
        },
        mounted() {
        },
    });
</script>

<style lang="scss" scoped>
    #app {
        .cell-value-spacing {
            padding: 0 0 5px 0;
        }

        .task-border-right {
            border-right: 2px solid var(--off-white);
        }

        .task-border-left {
            border-left: 2x solid var(--off-white);
        }
    }
</style>